import React from "react";
import { Link } from "react-router-dom";

const Expenses = ({ onMenuClick, active }) => {
  return (
    <>
      <li className="nav-item">
        <Link
          to
          className={`nav-link with-sub ${
            active === "/accounts" ||
            active === "/chart-of-account" ||
            active === "/budget-plan" ||
            active === "/journal-code" ||
            active === "/sub-category" ||
            active === "/journal-voucher" ||
            active === "/cash-count" ||
            active === "/setup"
              ? "active show-sub"
              : ""
          }`}
        >
          <i className="fa fa-briefcase" aria-hidden="true"></i>
          <span>&nbsp;&nbsp; Expenses</span>
        </Link>
        <ul className="nav-sub">
          {/* Supply Chain Expenses */}

          <li className="nav-item">
            <Link
              to="/expense-categories"
              className={`nav-link ${
                active === "/expense-categories" ? "active" : ""
              }`}
              onClick={() => onMenuClick("/expense-categories")}
            >
              <i className="fa fa-list" aria-hidden="true"></i>
              &nbsp;&nbsp; Expense Categories
            </Link>
          </li>
          <li className="nav-item">
            <Link
              to="/expenses"
              className={`nav-link ${active === "/expenses" ? "active" : ""}`}
              onClick={() => onMenuClick("/expenses")}
            >
              <i className="fa fa-credit-card" aria-hidden="true"></i>
              &nbsp;&nbsp; Expenses
            </Link>
          </li>
          <li className="nav-item">
            <Link
              to="/vendor-payments"
              className={`nav-link ${
                active === "/vendor-payments" ? "active" : ""
              }`}
              onClick={() => onMenuClick("/vendor-payments")}
            >
              <i className="fa fa-truck" aria-hidden="true"></i>
              &nbsp;&nbsp; Vendor Payments
            </Link>
          </li>
        </ul>
      </li>
    </>
  );
};

export default Expenses;
